export const OTHER_CLS_CODE = '5622AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA';

export const OTHER_CLS_IMAGE_DISPLAY = 'Chẩn đoán hình ảnh khác';
export const OTHER_CLS_DISPLAY = 'Chỉ định Cận lâm sàng khác';
export const OTHER_CLS_LABEL = 'Khác';
